import { Compass } from "lucide-react";

// The big olive concierge band that appears across the site (Home, Destinations, About).
// Renders the same content everywhere — single source of truth for the copy/CTA.
export default function ConciergeBand() {
  return (
    <section className="bg-olive text-bg" data-testid="concierge-band">
      <div className="max-w-8xl mx-auto px-6 md:px-12 py-20 md:py-28 grid md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-2 hidden md:flex"><Compass size={64} strokeWidth={1.2}/></div>
        <div className="md:col-span-7">
          <div className="font-serif text-4xl md:text-6xl leading-[1.02]">An AI concierge,<br/>trained on the articles.</div>
          <p className="mt-6 max-w-xl text-bg/75 text-base leading-relaxed">
            Want to know where to eat in Mayfair, the height of the Burj Khalifa, where to find a synagogue in Abu Dhabi or whether to wear a coat in Abha? Then ask the AI concierge who has read all of the articles on this site.
          </p>
        </div>
        <div className="md:col-span-3 flex md:justify-end">
          <button
            onClick={() => window.dispatchEvent(new Event("open-chatbot"))}
            className="inline-flex items-center gap-3 bg-bg text-ink px-6 py-4 text-[0.78rem] uppercase tracking-[0.2em] font-semibold hover:bg-ochre transition-colors"
            data-testid="concierge-cta"
          >
            <Compass size={18} strokeWidth={1.8}/> Ask the concierge
          </button>
        </div>
      </div>
    </section>
  );
}
